import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import {   SelectBox, TextArea} from 'devextreme-react';
import CheckBox from 'devextreme-react/check-box';
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function ResidentCardForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const zoneTypes=["Madrid","Barcelona","Otros"];

useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
    }
},[])

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
    }
},[types])


function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)  
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                <InputWrapper classes={classes} label={"Dirección"}>
                    <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid}> 
                    <InputWrapper classes={classes} label={"DNI"}>
                        <TextBox key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                        <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"MTR"}>
                        <CheckBox key={"mtr"} name="mtr" value={dataForm?.mtr? dataForm.mtr : false} onValueChanged={(e) => onChange("mtr", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Zona"}>
                        <SelectBox value={dataForm?.zone} onValueChanged={(e) => onChange("zone",e.value)} placeholder="" dataSource={zoneTypes} showClearButton height={25}></SelectBox>
                    </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Notas"}>
                    <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
                </InputWrapper>
        </div>
    )
}

export { ResidentCardForm}